module.exports = __webpack_public_path__ + "img/index_logo.f852a3d5.png";